import { all, call, fork, takeLatest } from 'redux-saga/effects'
import * as JD from 'domain/manager/jobDrafts'

export function* jobDraftsList({ query }: { query: JD.ManagerJobDraftsParams }) {
  yield all([fork(importJobDraft), call(getJobDraftsList, query)])
}

function* getJobDraftsList(query: JD.ManagerJobDraftsParams) {
  yield call(JD.ensureGetManagerJobDrafts, {
    payload: query || {},
    type: JD.managerJobDraftsList.request
  })
}

function* importJobDraft() {
  yield takeLatest(JD.importManagerJobDraft.TRIGGER, JD.ensureImportManagerJobDraft)
}
